<script>

import * as bootstrap from 'bootstrap';
window.bootstrap = bootstrap

import { useToast } from "vue-toastification";
import MyPagination from '@/components/SystemElements/PaginationV2.vue'
import MyCountRecords from '@/components/SystemElements/CountRecordsOptionsV2.vue'

import ParameterEdit from '@/pages/Core/Parameters/ParameterEdit.vue'
import ParameterDelete from '@/pages/Core/Parameters/ParameterDelete.vue'

import UserCircle from '@/ui/UserCircle'

//store
import {useSelectedItemStore} from "@/stores/selectedItem";

import LoadingScreen from '@/components/General/LoadingScreen'
import Alert from '@/components/General/Alert'

//general functions
import MixinGeneralFunct from '@/mixins/GeneralFunctions';

//data
import { getParameters,unlockParameter } from '@/services/serviceParameter';

export default {
	setup() {
		let selectedItemStore = useSelectedItemStore();
		const allSelectedItems = selectedItemStore.getAllSelectedItems;

		const toast = useToast();
		return { toast, allSelectedItems, selectedItemStore }
	},
	name: 'Parameters',
	mixins: [ MixinGeneralFunct ],
	components: {
		UserCircle
		,ParameterEdit,ParameterDelete
		,MyPagination,MyCountRecords
		,LoadingScreen
		,Alert
	},
	props: ["auth","secData","params"],
	data() {
		return {
			metaData:[],
			
			isLoading:true,
			
			totalCount:0,
			dataList:[],
			selectedFilterText:'',
			
			selectedParameterId:'',
			
			

			selectedPage:1,
			selectedRecords:10,
			selectedCol:'a.title',
			selectedSort:'asc',
			
			checkAllItems:false,
			
			showFilter:false,
			filterExtended:false,
			
			showedHelpbox:false,

			modalDelete:{},
			modalDeleteId:'',
			
			modalEdit:{},
			modalEditId:'',
		}
	},
	
	mounted:function(){
		this.modalDeleteId = `modal${this.getRandomInt(999999999)}`;
		this.modalEditId = `modal${this.getRandomInt(999999999)}`;
	},
	
	methods: {
		
		//na fontende aj preview aj tabula, zober povodne idcka a idcka po aktualizacii a tie naviac zobraz na par sekund inou farbou, alebo ako nove.
		
		//default data
		
		
		onLoadPage:function(){
			
			//show loader
			this.isLoading=true
			
			getParameters({filterText: this.selectedFilterText, orderCol: this.selectedCol, orderSort: this.selectedSort, page: this.selectedPage, records: this.selectedRecords}).then(response => {
				console.log(response)
				if(!response.statusText){
					this.isLoading=false
					this.dataList = response.results;
					this.metaData = response.metaData;
					this.totalCount = response.totalCount;

					//oznacenie poloziek cez strankovac
					for(let i = 0; i < this.dataList.length; i++){
						if(this.allSelectedItems.indexOf(this.dataList[i].id)>=0){
							this.dataList[i].selectedId=true;
						}
					}
				}else{
					this.isLoading=false
					this.errorStatus=`${response.statusText} ${response.status}`
				}
			});
			
		
		
		},
		
				
		//odomknutie zaznamu
		onUnLock:function(parameterId){
			this.cSession();
			this.isLoading=true
			unlockParameter({parameterId}).then(response => {
				console.log(response)
				if(!response.statusText){
					this.isLoading=false
					if(response.resCode==1){
						this.toast.success(this.$t('msgCore.dataWasUnlocked'));
						this.onLoadPage();
					}else if(response.resCode==0){
						this.toast.warning(this.$t('msgCore.dataCantBeUnlocked'));
					}else if(response.resCode==2){
						this.toast.error(this.$t('msgCore.dataWasNotUnlocked'));
					}else if(response.resCode==3){
						this.toast.error(this.$t('msgCore.accessDenied'));
					}
					
				}else{
					this.isLoading=false
					this.toast.error(`${response.statusText} ${response.status}`);
				}
			});
		},
		
		
		//(od)oznacenie vsetkych poloziek
		onCheckAllItems:function(){
			if(this.checkAllItems){
				for(let i = 0; i < this.dataList.length; i++){
					this.dataList[i].selectedId=true;
					if(this.allSelectedItems.indexOf(this.dataList[i].id)==-1){
						this.selectedItemStore.addSelectedItems(this.dataList[i].id);
					}
				}
			}else{
				for(let i = 0; i < this.dataList.length; i++){
					this.dataList[i].selectedId=false;
					var indexToRemove = this.allSelectedItems.indexOf(this.dataList[i].id);
					if(indexToRemove>=0){
						this.selectedItemStore.deleteSelectedItems(indexToRemove);
					}
				}
			}
		},
		
		//oznacenie jednej polozky
		onCheckItem:function(index,id){
			if(this.dataList[index].selectedId==true){
				this.selectedItemStore.addSelectedItems(id);
			}else{
				var indexToRemove = this.allSelectedItems.indexOf(id);
				this.selectedItemStore.deleteSelectedItems(indexToRemove);
			}
		},

		//zrusenie vyberu
		onResetSelected:function(){
			for(let i = this.allSelectedItems.length; i>=0 ;i--){
				var indexToRemove = this.allSelectedItems.indexOf(this.allSelectedItems[i]);
				if(indexToRemove>=0){
					var index = this.dataList.findIndex(item => item.id==this.allSelectedItems[i]); 
					if(index>=0){
						this.dataList[index].selectedId=false;
					}
					this.selectedItemStore.deleteSelectedItems(indexToRemove);
				}
			}
		},
		
		//radenie zoznamu - orders by
		orderByCol:function(col){
			
			if(col === this.selectedCol) {
				this.selectedSort = this.selectedSort==='asc'?'desc':'asc';
			}
			this.selectedCol = col;
			
			this.onLoadPage();
		},
		


		//active menu
		isActive: function (col) {
			return this.selectedCol === col;
		},
		isAsc: function (col) {
			if(this.selectedCol === col && this.selectedSort === 'asc'){
				return true;
			}
		},
		isDesc: function (col) {
			if(this.selectedCol === col && this.selectedSort === 'desc'){
				return true;
			}
		},
		
		
		
		//zobrazi filtre
		showFilters: function(){
			if(!this.showFilter) {
				this.showFilter = true;
			}else{
				this.showFilter = false;
			}
		},
		
		//vycisti text filter
		resetTextFilter: function(){
			this.selectedFilterText = '';
			this.onLoadPage();
		},
		
		// zobrazi napovedu
		showHelpbox: function(){
			if(!this.showedHelpbox) {
				this.showedHelpbox = true;
			}else{
				this.showedHelpbox = false;
			}
		},
		// systemove funkcie k zoznamu KONIEC
		
		
		//modal box user editacia
		loadModalFormParameterEdit:function(recordID){
			this.cSession();
			//console.log(recordID)
			this.selectedParameterId=recordID;
			this.modalEdit = new bootstrap.Modal(document.getElementById(this.modalEditId), {backdrop:'static'})
			this.modalEdit.show();
		},
		
		//modal box user delete
		loadModalFormParameterDelete:function(recordID){
			this.cSession();
			//console.log(recordID)
			this.selectedParameterId=recordID;
			this.modalDelete = new bootstrap.Modal(document.getElementById(this.modalDeleteId), {backdrop:'static'})
			this.modalDelete.show();
		},
		
		//zmena zaznamu
		onChangeItem() {
			this.onLoadPage();
			this.selectedParameterId='';
		},

		//vyber stranky v strankovaci
		onChangePage(selectedPage) {
			this.selectedPage=selectedPage
			this.onLoadPage();
		},

		//vyber poctu zaznamov
		onChangeRecords(selectedCount) {
			this.selectedPage=1;
			this.selectedRecords=selectedCount
			this.onLoadPage();
		},

		
	},	
	
			
	watch: {
		'auth.parametersList': function () {
			this.onLoadPage();
		}
	},

	computed:{
		
	},
	
}

</script>

<template>
	<div>
	<LoadingScreen :isLoading="isLoading"></LoadingScreen>
	<div id="version" class="version"><p>{{metaData.version}}</p></div>
				
		<div v-if="metaData.modulAccess"> 
		
			<div class="row">
				<div class="col-12">
				
				
					<div class="row">
						<div class="col-6">
							<h5>{{ $t('msgCore.Parameters') }}</h5>	 
						</div> 
						
						<div class="col-6 right">
							
							<button type="button" :disabled="!auth.levelsNew" v-on:click="loadModalFormParameterEdit(null)" class="btn btn-primary btn-sm"><i class="smire-icon fas fa-plus"></i> {{ $t('msgCore.btnAdd') }}</button>
							
						</div> 
					</div>
																	
							
					<!-- filters basic -->
					<div class="row">
					
						<div class="input-group col-md-4 col-12">
							<button type="button" :title="$t('msgCore.btnFilter')" class="btn btn-info btn-sm my-btn" v-on:click="showFilters()">
								<span v-if="filterExtended">
									<i v-if="!showFilter" class="smire-icon fas fa-search-plus"></i> 
									<i v-else class="smire-icon fas fa-search-minus"></i>
								</span>
								<span v-else>
									<i class="smire-icon fas fa-search"></i> 
								</span>
								{{ $t('msgCore.btnFilter') }}
							</button>
							<input type="text" class="form-control form-control-sm" v-model='selectedFilterText' :placeholder="$t('msgCore.searchTitle')" v-on:change="onLoadPage()">
							<button type="button" :title="$t('msgCore.btnStorno')" class="btn btn-outline-info btn-sm my-btn" v-on:click="resetTextFilter()">
								<i class="smire-icon fas fa-times"></i>
							</button>
						</div>
						
					</div>

					<!-- filters extended -->
					<div v-show="showFilter && filterExtended" class="row">
						<div class="input-group form-group-filter col-12">
						</div>
					</div>
					
				</div>
			</div>				
			
			<!-- zakladny zoznam -->
			<div v-if="totalCount>0">
			
				<div class="row">
					<div class="col-12">
	
						<div class="table-responsive">
							<table class="table table-hover table-sm">
							
								<thead>
									<tr>
										<th class="orderBy" v-on:click="orderByCol('a.id')" :class="{ active: isActive('a.id'), asc: isAsc('a.id'), desc: isDesc('a.id')}">ID</th>

										<th width="10" class="align-middle"><div class="form-check"><label class="form-check-label"><input v-model="checkAllItems" v-on:change="onCheckAllItems()" class="form-check-input" type="checkbox"><span class="form-check-sign"><span class="check"></span></span></label></div></th>
										
										<th>
											{{$t('msgCore.Action')}}
										</th>
										
										<th>{{$t('msgCore.State')}}</th>
										
										<th>{{$t('msgCore.Type')}}</th>
										
										<th>{{$t('msgCore.Title')}}</th>
										
										<th>{{$t('msgCore.Value')}}</th>
										
										<th>{{$t('msgCore.Note')}}</th>
										
										<th>{{$t('msgCore.Created')}}</th>
										
										<th>{{$t('msgCore.Modified')}}</th>
										
										<th>{{$t('msgCore.AccessLevel')}}/{{$t('msgCore.Users')}}</th>
										
																			
									</tr>
								</thead>
								
								
								<tr v-for="(basicObj, index) in dataList" :key="basicObj" >
								
									<td>{{ basicObj.id }}</td>
								
									<td class="align-middle">
										<div class="form-check">
											<label class="form-check-label">
											<input v-model.number='basicObj.selectedId' class="form-check-input" type="checkbox" v-on:change="onCheckItem(index,basicObj.id);">
											<span class="form-check-sign"><span class="check"></span></span>
											</label>
										</div>	
									</td>
								
									<td>
										<div class="input-group">	
											
											<button v-if="basicObj.isCheckedOut" type="button" :disabled="!auth.parametersUnlock" v-on:click="onUnLock(basicObj.id)" v-bind:title="basicObj.checkedOutName+', '+basicObj.isCheckedOutDate" class="btn btn-sm"><i class="smire-icon fas fa-lock"></i></button>
																				
											<div class="btn-group">				
												<button type="button" :disabled="!auth.parametersEdit" v-on:click="loadModalFormParameterEdit(basicObj.id)" :title="$t('msgCore.btnEdit')" id="myModalBtn" class="btn btn-secondary btn-sm"><i class="fas fa-edit"></i></button>
										
												<button v-if="basicObj.isAllowedRemove" type="button" :disabled="!auth.parametersDelete" v-on:click="loadModalFormParameterDelete(basicObj.id)" :title="$t('msgCore.btnDelete')" id="myModalBtn" class="btn btn-danger btn-sm"><i class="fas fa-trash-alt"></i></button>
															
											</div>	
											
											
											
										</div>	
									</td>
									
									<td :title="basicObj.state_name">
										<i class="fas fa-circle" :class="{'text-success':basicObj.state==1,'text-danger':basicObj.state==2}" ></i>
									</td>	
									
									<td >{{ basicObj.parameter_type_name }}</td>
									
									<td >{{ basicObj.title }}</td>							
									
									<td >{{ basicObj.value }}</td>
									
									<td >{{ basicObj.description }}</td>
									
									<td>
											<UserCircle :firstName="basicObj.creatorFirstName" :surName="basicObj.creatorSurName" :color="basicObj.creatorColor" :date="basicObj.created"/>
                                        </td>

										<td>
											<UserCircle :firstName="basicObj.editorFirstName" :surName="basicObj.editorSurName" :color="basicObj.editorColor" :date="basicObj.modified"/>
                                        </td>
									
								
									<td >{{ basicObj.access_name }}<br>
									
										<span v-for="(user) in basicObj.users" :key="user">
											<span >{{ user.name }} {{ user.surname }}</span>,
										</span>
									
									</td>
									
									
								</tr>
									

							
							</table>	
						</div>		
					
					</div>
				</div>
					
				<div class="row row-pagination">
					<div class="col-6 col-md-3 col-lg-2">
						<MyCountRecords :selectedRecords="selectedRecords" @onSelectRecords="onChangeRecords"></MyCountRecords>
					</div>
					
					<div class="col-6 col-md-3 col-lg-2 box-flex">
						<span>Počet: {{totalCount}} <button v-if="allSelectedItems.length>0" type="button" @click="onResetSelected()" class="btn btn-sm btn-info">Vybr.:{{ allSelectedItems.length }} <i class="fas fa-times"></i></button></span>
					</div>
					
					<div class="col-12 col-md-6 col-lg-8">	
						<MyPagination :selectedRecords="selectedRecords" :totalCount="totalCount" :selectedPage="selectedPage" @onSelectPage="onChangePage"></MyPagination>
					</div>
				</div>	
				
			</div>	
					
			<div v-else class="row">
				<div class="col-12 mt-3">
					<Alert type="warning" :label="$t('msgCore.forThisSelectExistAnyData')" />
				</div>							
			</div>
						
								
		</div>
			
			
		
		<div v-else >
			<div class="row">
				<div class="col-12 mt-3">
					<Alert type="warning" :label="$t('msgCore.accessDenied')" />
                </div>
			</div>
		</div>
	
		<ParameterEdit :auth="auth" :secData="secData" :parameterId="String(selectedParameterId)" @changeRecord="onChangeItem" :modalObject="modalEdit" :modalId="modalEditId"></ParameterEdit>
		
		<ParameterDelete :auth="auth" :secData="secData" :parameterId="String(selectedParameterId)" @changeRecord="onChangeItem" :modalObject="modalDelete" :modalId="modalDeleteId"></ParameterDelete>
	
	</div>	
</template>


